module.exports = __webpack_public_path__ + "static/image1-42f42e155015c3263e90b6245f3d1659.jpg";